export default __webpack_public_path__ + "static/media/konversacio.1db21575.svg";